import { useCallback, useMemo, useState } from 'react';
import { IS_WEB } from '@/shared/constants/utility';

export interface WebHoverHandlers {
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export function useWebHoverToggle(): {
  isHovered: boolean;
  webHoverProps: WebHoverHandlers;
} {
  const [isHovered, setHovered] = useState(false);
  const onEnter = useCallback(() => {
    setHovered(true);
  }, []);
  const onLeave = useCallback(() => {
    setHovered(false);
  }, []);

  const webHoverProps = useMemo(() => {
    if (!IS_WEB) {
      return {};
    }
    return {
      onMouseEnter: onEnter,
      onMouseLeave: onLeave,
    };
  }, [onEnter, onLeave]);

  return { isHovered, webHoverProps };
}
